import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../../context/DataContext';
import SelectField from '../../components/form/SelectField';

const CheckOrderInfoPage = () => {
  const navigate = useNavigate();
  const { state, saveOrderInfo, setCustomerInfo, resetOrderStatus } = React.useContext(Context);
  const {
    customerInfo,
    paymentList,
    loginInfo: { empNo, tokenLogin },
  } = state;
  const [paymentMethod, setPaymentMethod] = React.useState('');
  const [periodType, setPeriodType] = React.useState('');
  const [warrantyMonth, setWarrantyMonth] = React.useState('');
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const paymentInfo = paymentMethod
    ? paymentList.find(
        ({ PaymentType, PeriodType, WarrantyMonth }) =>
          PaymentType === paymentMethod &&
          PeriodType === periodType &&
          String(WarrantyMonth) === warrantyMonth
      )
    : {};

  React.useEffect(() => {
    if (!tokenLogin) {
      resetOrderStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        資訊確認
      </Typography>
      <Box sx={{ px: 2, textAlign: 'left' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
          機型：{customerInfo.market_n} {customerInfo.capacity ? `${customerInfo.capacity}GB` : ''}
        </Typography>
        <Typography variant="h6" sx={{ my: 2 }}>
          IMEI：{customerInfo.imei}
        </Typography>
        <Typography variant="h6" sx={{ my: 2 }}>
          服務名稱：
          {[...new Set(paymentList.map(({ InsuranceName }) => InsuranceName))][0]}
        </Typography>
        <SelectField
          fullWidth
          id="payment-method"
          label="付款方式"
          placeholder="請選擇..."
          value={paymentMethod ? `${paymentMethod}+${periodType}+${warrantyMonth}` : ''}
          onChange={(e) => {
            const [paymentMethod, periodType, warrantyMonth] = e.target.value.split('+');
            setPaymentMethod(paymentMethod);
            setPeriodType(periodType);
            setWarrantyMonth(warrantyMonth);
          }}
          options={paymentList.map(
            ({ PaymentType, PaymentTypeName, PeriodType, WarrantyMonth }) => ({
              id: `${PaymentType}+${PeriodType}+${WarrantyMonth}`,
              value: `${PaymentType}+${PeriodType}+${WarrantyMonth}`,
              text: PaymentTypeName,
            })
          )}
        />
        {paymentMethod ? (
          <>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`保險費：${paymentInfo.InsurancePrice}元`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`置換費用：${paymentInfo.SwapPrice}元`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`生效日期：${paymentInfo.InsuranceStartDate}`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`到期日期：${paymentInfo.InsuranceEndDate}`}
            </Typography>
            {errorMsg ? (
              <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
                {errorMsg}
              </Typography>
            ) : null}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <Button
                color="secondary"
                variant="contained"
                sx={{ width: 128 }}
                onClick={() => {
                  navigate('/dashboard');
                }}
              >
                不同意
              </Button>
              <LoadingButton
                variant="contained"
                sx={{ width: 128 }}
                loading={loading}
                onClick={() => {
                  // navigate('/extend-new/agreement-confirm');
                  setLoading(true);
                  // Save order info first to get orderId
                  const {
                    InsurancePrice,
                    InsuranceName,
                    PaymentExecTimes,
                    SwapPrice,
                    PeriodType,
                    WarrantyMonth,
                    PaymentTypeName,
                    InsuranceStartDate,
                    InsuranceEndDate,
                  } = paymentInfo;

                  saveOrderInfo(
                    {
                      brand: customerInfo.brand,
                      model: customerInfo.market_n,
                      imei: customerInfo.imei,
                      capacity: customerInfo.capacity,
                      price: InsurancePrice,
                      creatorId: '-1',
                      realModel: customerInfo.model,
                      serial: '',
                      color: '',
                      examToken: '',
                      deviceStatus: '',
                      status: '',
                      op: empNo,
                      isConsumer: '',
                      isPayeasy: '',
                      isRemoteRecycle: '',
                      orderType: 'ext_warranty',
                    },
                    ({ responseCode, responseMsg }) => {
                      setLoading(false);
                      if (responseCode === '000') {
                        setCustomerInfo(
                          {
                            payType: paymentMethod,
                            insurancePrice: InsurancePrice,
                            serviceName: InsuranceName,
                            fromDate: InsuranceStartDate,
                            toDate: InsuranceEndDate,
                            validPeriod: PaymentExecTimes,
                            swapPrice: SwapPrice,
                            periodType: PeriodType,
                            warrantyMonth: WarrantyMonth,
                            paymentText: PaymentTypeName,
                          },
                          () => {
                            navigate('/extend-new/agreement-confirm');
                          }
                        );
                      } else {
                        setErrorMsg(responseMsg);
                      }
                    }
                  );
                }}
              >
                下一步
              </LoadingButton>
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default CheckOrderInfoPage;
